module.exports = __webpack_public_path__ + "static/media/a.354ad47d.gif";